import N from "./index.es422.js";
import P from "./index.es423.js";
import R from "./index.es424.js";
import z from "./index.es425.js";
import B from "./index.es426.js";
import E from "./index.es427.js";
import G from "./index.es428.js";
import H from "./index.es429.js";
import K from "./index.es430.js";
import M from "./index.es431.js";
import Q from "./index.es432.js";
import U from "./index.es433.js";
import { generateSheets as V } from "./index.es434.js";
var X = ["fileName"];
function b(e, r) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Y(e)) || r) {
    t && (e = t);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y(e, r) {
  if (e) {
    if (typeof e == "string") return w(e, r);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? w(e, r) : void 0;
  }
}
function w(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, o = Array(r); t < r; t++) o[t] = e[t];
  return o;
}
function q(e, r) {
  if (e == null) return {};
  var t, o, a = D(e, r);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    for (o = 0; o < l.length; o++) t = l[o], r.indexOf(t) === -1 && {}.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
  }
  return a;
}
function D(e, r) {
  if (e == null) return {};
  var t = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (r.indexOf(o) !== -1) continue;
    t[o] = e[o];
  }
  return t;
}
function ue(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.fileName, o = q(r, X);
  return J(e, o).then(function(a) {
    return t ? P.saveAs(a, t) : a;
  });
}
function J(e, r) {
  var t = r.sheet, o = r.sheets, a = r.schema, l = r.columns, d = r.images, S = r.headerStyle, x = r.getHeaderStyle, k = r.fontFamily, C = r.fontSize, A = r.orientation, h = r.stickyRowsCount, y = r.stickyColumnsCount, O = r.showGridLines, I = r.rightToLeft, F = r.dateFormat, m = new N(), u = V({
    data: e,
    sheetName: t,
    sheetNames: o,
    schema: a,
    columns: l,
    images: d,
    headerStyle: S,
    getHeaderStyle: x,
    fontFamily: k,
    fontSize: C,
    orientation: A,
    stickyRowsCount: h,
    stickyColumnsCount: y,
    showGridLines: O,
    rightToLeft: I,
    dateFormat: F
  }), f = u.sheets, L = u.getSharedStrings, T = u.getStyles;
  m.file("_rels/.rels", E), m.file("[Content_Types].xml", G({
    sheets: f,
    images: d
  }));
  var n = m.folder("xl");
  n.file("_rels/workbook.xml.rels", B({
    sheets: f
  })), n.file("workbook.xml", z({
    sheets: f,
    stickyRowsCount: h,
    stickyColumnsCount: y
  })), n.file("styles.xml", U(T())), n.file("sharedStrings.xml", Q(L()));
  for (var _ = b(f), g; !(g = _()).done; ) {
    var c = g.value, i = c.id, $ = c.data, s = c.images;
    if (n.file("worksheets/sheet".concat(i, ".xml"), $), n.file("worksheets/_rels/sheet".concat(i, ".xml.rels"), M({
      id: i,
      images: s
    })), s) {
      n.file("drawings/drawing".concat(i, ".xml"), H({
        images: s
      })), n.file("drawings/_rels/drawing".concat(i, ".xml.rels"), K({
        images: s,
        sheetId: i
      }));
      for (var j = b(s), p; !(p = j()).done; ) {
        var v = p.value;
        n.file("media/".concat(R(v, {
          sheetId: i,
          sheetImages: s
        })), v.content);
      }
    }
  }
  return m.generateAsync({
    type: "blob",
    mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    compression: "deflate"
  });
}
export {
  ue as default
};
//# sourceMappingURL=index.es364.js.map
